import {
  faGithub, faLinkedin, faTwitter, faInstagram, faMedium,
} from '@fortawesome/free-brands-svg-icons';

const data = [
  {
    icon: faGithub,
    href: 'https://github.com/KingsleyIbe',
    alt: 'Github Icon',
    target: '_blank',
  },
  {
    icon: faLinkedin,
    href: 'https://www.linkedin.com/in/kingsley-ibe-5669a5134/',
    alt: 'Linkedin Icon',
    target: '_blank',
  },
  {
    icon: faMedium,
    href: 'https://medium.com/@ibekingsley',
    alt: 'Medium Icon',
    target: '_blank',
  },
  {
    icon: faTwitter,
    href: 'https://twitter.com/ibekingsley2',
    alt: 'Twitter Icon',
    target: '_blank',
  },
  {
    icon: faInstagram,
    href: 'https://instagram.com/ibekingsleychibueze',
    alt: 'Instagram Icon',
    target: '_blank',
  },
];

export default data;
